import React from 'react'
import { BiLogoLinkedin } from "react-icons/bi";
import mentor1 from './image/mentor1.jpg';
import mentor2 from './image/mentor2.jpeg';
import mentor3 from './image/mentor3.jpg';
import mentor4 from './image/mentor4.jpg';

function All_Program_Mentor() {
  return (
    <div>
    {/* ----------------mobile View-------------------- */}
    <div className='d-sm-block d-md-none'>
    <div className='bg-white'>
    <div className='container py-4'>
        <div className='text-center'>
        <span className=" display-6 Mentor_component_text ">Meet Our Mentors</span>
            <p className="pt-3">A luminary for your success: meet the outstanding mentors who will encourage, uplift, and advance you towards achievement.</p>
        </div>
        <div className='row'>
        <div className='col-6'>
                <div className='py-3'>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor1}
                    className="rounded-circle shadow-1-strong mobile_view_Mentor_card_img"
                    />
                </div>
                <div className='text-center mobile_mentor_text'>
                <h4 className="mb-2"> Ayan Kumar Ghosh</h4>
                <p className="mb-2">Artificial intelligence/Machine Learning Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/akghsh?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
            <div className='col-6'>
                <div className='py-3'>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor2}
                    className="rounded-circle shadow-1-strong mobile_view_Mentor_card_img"
                    />
                </div>
                <div className='text-center mobile_mentor_text'>
                <h4 className="mb-2">Abhishek Garg</h4>
                <p className="mb-2">DSA <br></br>Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/abhishek-garg-profile' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
            <div className='col-6'>
            <div className='py-3'>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor3}
                    className="rounded-circle shadow-1-strong mobile_view_Mentor_card_img"
                    />
                </div>
                <div className='text-center mobile_mentor_text'>
                <h4 className="mb-2">Mukesh Joshi</h4>
                <p className="mb-2 ">Web Development<br></br> Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/mukesh-joshi-87444b163?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
            <div className='col-6'>
            <div className='py-3'>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor4}
                    className="rounded-circle shadow-1-strong mobile_view_Mentor_card_img"
                    />
                </div>
                <div className='text-center mobile_mentor_text'>
                <h4 className="mb-2">Aman Gupta</h4>
                <p className="mb-2">Cyber Security/Cloud Computing Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/amanguptaiam?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>

    {/* ----------------------Desktop View---------------------- */}
    <div className='d-none d-md-block'>
    <div className='bg-white'>
    <div className='container py-5'>
        <div className='text-center'>
        <span className=" display-5 Mentor_component_text ">Meet Our Mentors</span>
            <p className="py-4 fs-5 py-3 mb-md-5 pb-md-0">A luminary for your success: meet the outstanding mentors who will encourage, uplift, and advance you towards achievement.</p>
        </div>
        <div className='row py-3'>
        <div className='col-md-3'>
                <div>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor1}
                    className="rounded-circle shadow-1-strong Mentor_card_img"
                    />
                </div>
                <div className='text-center Mentor_name_text'>
                <h4 className="mb-2">Ayan Kumar Ghosh</h4>
                <p className="mb-2">Artificial intelligence/Machine<br></br> Learning Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/akghsh?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
            <div className='col-md-3'>
                <div>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor2}
                    className="rounded-circle shadow-1-strong Mentor_card_img"
                    />
                </div>
                <div className='text-center Mentor_name_text'>
                <h4 className="mb-2">Abhishek Garg</h4>
                <p className="mb-2 Mentor_name_text">DSA <br></br>Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/abhishek-garg-profile' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
            <div className='col-md-3'>
            <div>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor3}
                    className="rounded-circle shadow-1-strong Mentor_card_img"
                    />
                </div>
                <div className='text-center Mentor_name_text'>
                <h4 className="mb-2">Mukesh Joshi</h4>
                <p className="mb-2 Mentor_name_text">Web Development <br></br> Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/mukesh-joshi-87444b163?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
            <div className='col-md-3'>
            <div>
                <div className='d-flex justify-content-center mb-4'>
                <img
                    src={mentor4}
                    className="rounded-circle shadow-1-strong Mentor_card_img"
                    />
                </div>
                <div className='text-center Mentor_name_text'>
                <h4 className="mb-2">Aman Gupta</h4>
                <p className="mb-2 Mentor_name_text">Cyber Security/Cloud Computing <br></br>Expert</p>
                </div>
                <div className='d-flex justify-content-center'>
                <div className='text-center pt-2'>
                <a href='https://www.linkedin.com/in/amanguptaiam?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target='_blank'><BiLogoLinkedin  size="40px" color="#3d2e7c" className='border rounded-pill p-2' /></a>
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    </div>
    </div>
  )
}

export default All_Program_Mentor
